/*
===============================================================================================================
                                 Copyright 2022-2022, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import { AuthContext } from '@/contexts/auth-context';
import { MerchantContext } from '@/contexts/merchant-context';

function Home() {
  const router = useRouter();
  const { isUserLoggedIn } = useContext(AuthContext);
  const { merchantId } = useContext(MerchantContext);

  const newRoute = isUserLoggedIn ? `/${merchantId}/details` : `/${merchantId}/login`;
  router.push(newRoute);
  return <></>;
}

export default Home;
